import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useCallback } from 'react';
import { TextField, Loader } from '@finam/web-ui-kit';
import styled from 'styled-components';
var Root = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var LoaderIcon = styled(Loader)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 12px;\n  width: 24px;\n  height: 56px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.fill.primary.mid;
});
var CodeTextField = forwardRef(function (_a, ref) {
  var loading = _a.loading,
      disabled = _a.disabled,
      className = _a.className,
      initialError = _a.initialError,
      value = _a.value,
      codeLength = _a.codeLength,
      onChange = _a.onChange,
      props = __rest(_a, ["loading", "disabled", "className", "initialError", "value", "codeLength", "onChange"]);

  var handleCodeChange = useCallback(function (event) {
    var formattedValue = (event.target.value || '').replace(/[^\d]/, '');

    if (formattedValue !== value && onChange) {
      event.target.value = formattedValue;
      onChange(event);
    }
  }, [value, onChange]);
  return _jsx(Root, Object.assign({
    className: className
  }, {
    children: _jsx(TextField, Object.assign({
      type: "tel",
      pattern: "[0-9]*",
      maxLength: codeLength,
      formNoValidate: true,
      autoComplete: "one-time-code",
      autoCapitalize: "none",
      variant: "outline",
      disabled: disabled || loading,
      value: value,
      icon: loading && !disabled && _jsx(LoaderIcon, {}),
      hintTooltipPlacement: "right",
      ref: ref
    }, props, {
      onChange: handleCodeChange
    }))
  }));
});
export default memo(CodeTextField);